

export class TooltipOptionOutput implements ITooltipOptionOutput {
    /** The auto-generated id of the tool tip option  master */
    tooltip_option_id!: number;
    /** The auto-generated id of the tool tip header  master */
    tooltip_header_id!: number;

    constructor(data?: ITooltipOptionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tooltip_option_id = _data["tooltip_option_id"];
            this.tooltip_header_id = _data["tooltip_header_id"];
        }
    }

    static fromJS(data: any): TooltipOptionOutput {
        data = typeof data === 'object' ? data : {};
        let result = new TooltipOptionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tooltip_option_id"] = this.tooltip_option_id;
        data["tooltip_header_id"] = this.tooltip_header_id;
        return data; 
    }
}

export interface ITooltipOptionOutput {
    /** The auto-generated id of the tool tip option  master */
    tooltip_option_id: number;
    /** The auto-generated id of the tool tip header  master */
    tooltip_header_id: number;
}

